var map = {
	"./logo-school-1.png": "27ad",
	"./logo-school-10.png": "9616",
	"./logo-school-11.png": "bc57",
	"./logo-school-12.png": "72d2",
	"./logo-school-13.png": "4c94",
	"./logo-school-14.png": "e2e3",
	"./logo-school-2.png": "0388",
	"./logo-school-3.png": "6f18",
	"./logo-school-4.png": "d593",
	"./logo-school-5.png": "187f",
	"./logo-school-6.png": "eaec",
	"./logo-school-7.png": "b436",
	"./logo-school-8.png": "d0c4",
	"./logo-school-9.png": "3ee9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7733";